<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup marketingPopup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Change Leverage</span>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Change Leverage
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        You Can New Leverage From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>MT5 Account</legend>
              <v-select v-model="trading_account_no" :items="formattedMT5Accounts" item-text="text" item-value="value"
                solo append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Leverage</legend>
              <v-select v-model="newleverage" :items="leverageOptions" label="Select leverage" solo hide-details
                class="custom-select"></v-select>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="changeLeverage" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Confirm</v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      userId: "",
      dialogDeposit: false,
      trading_account_no: '',
      newleverage: "",
      leverageOptions: [
        { text: '1:1', value: '1' },
        { text: '1:2', value: '2' },
        { text: '1:3', value: '3' },
        { text: '1:5', value: '5' },
        { text: '1:10', value: '10' },
        { text: '1:15', value: '15' },
        { text: '1:20', value: '20' },
        { text: '1:25', value: '25' },
        { text: '1:33', value: '33' },
        { text: '1:40', value: '40' },
        { text: '1:50', value: '50' },
        { text: '1:66', value: '66' },
        { text: '1:75', value: '75' },
        { text: '1:80', value: '80' },
        { text: '1:100', value: '100' },
        { text: '1:125', value: '125' },
        { text: '1:150', value: '150' },
        { text: '1:175', value: '175' },
        { text: '1:200', value: '200' },
        { text: '1:300', value: '300' },
        { text: '1:400', value: '400' },
        { text: '1:500', value: '500' },
        { text: '1:1000', value: '1000' },
        { text: '1:5000', value: '5000' }
      ]
    };
  },
  computed: {
    ...mapState("reguserdetails", ["mt5Accounts"]),
    formattedMT5Accounts() {
      return this.mt5Accounts.map(account => ({
        text: `${account.trading_account_no} (1:${account.leverage})`,
        value: account.trading_account_no
      }));
    },

  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES, REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTLEVERAGE]),

    async changeLeverage() {
      await this[REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTLEVERAGE]({
        leverage: this.newleverage,
        trading_account_no: this.trading_account_no,
        userId: this.userId
      });
      this.dialogDeposit = false
    },
  },
  async mounted() {
    this.userId = this.$route.params.id
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES](this.$route.params.id);
  },
};
</script>